import React from "react";
import classes from "./Service.module.css";
import acupuncture from "../Assets/acupuncture.png";
import fst from "../Assets/FST.png";
import chiro from "../Assets/chiro.png";
import exercise from "../Assets/exercise.png";
import education from "../Assets/education.png";
import ortho from "../Assets/orthotics.png";

const Service = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>SERVICES WE OFFER</span>
      </h1>
      <div className={classes.imageContainer}>
        <div className={classes.imgSize}>
          <img src={chiro} alt="Chiropractic" />
          <span>
            <br />
            <center>Chiropractic adjustment</center>
            <br />
          </span>
        </div>
        <div className={classes.imgSize}>
          <img src={fst} alt="Fascial Stretch Therapy" />
          <span>
            <br />
            <center>Fascial Stretch Therapy</center>
            <br />
          </span>
        </div>
        <div className={classes.imgSize}>
          <img src={acupuncture} alt="Acupuncture" />
          <span>
            <br />
            <center>Functional integrated acupuncture</center>
            <br />
          </span>
        </div>
        <div className={classes.imgSize}>
          <img src={exercise} alt="exercise" />
          <span>
            <br />
            <center>Rehabilitative exercise</center>
            <br />
          </span>
        </div>
        <div className={classes.imgSize}>
          <img src={education} alt="education" />
          <span>
            <br />
            <center>Education</center>
            <br />
          </span>
        </div>
        <div className={classes.imgSize}>
          <img src={ortho} alt="Acupuncture" />
          <span>
            <br />
            <center>Orthotics</center>
            <br />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Service;
